<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-form-item label="主键" prop="id">
                <el-input clearable v-model="dataForm.id" ></el-input>
            </el-form-item>
            <el-form-item label="访客姓名" prop="guestName">
                <el-input clearable v-model="dataForm.guestName" ></el-input>
            </el-form-item>
            <el-form-item label="访客证件号码" prop="guestIdcard">
                <el-input clearable v-model="dataForm.guestIdcard" ></el-input>
            </el-form-item>
            <el-form-item label="健康状态" prop="guestHealthyStatus">
                <el-input clearable v-model="dataForm.guestHealthyStatus" ></el-input>
            </el-form-item>
            <el-form-item label="岗点id" prop="gdid">
                <el-input clearable v-model="dataForm.gdid" ></el-input>
            </el-form-item>
            <el-form-item label="来访时间" prop="time">
                <el-input clearable v-model="dataForm.time" ></el-input>
            </el-form-item>
            <el-form-item label="人员类型id" prop="guestTypeId">
                <el-input clearable v-model="dataForm.guestTypeId" ></el-input>
            </el-form-item>
            <el-form-item label="保安id" prop="userId">
                <el-input clearable v-model="dataForm.userId" ></el-input>
            </el-form-item>
            <el-form-item label="来访原因" prop="guestReason">
                <el-input clearable v-model="dataForm.guestReason" ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            const validateNumber = (rule, value, callback) => {
                var patrn = /^\d+(\.\d+)?$/;
                if (!patrn.exec(value)) {
                    callback(new Error('请填写数字'))
                } else {
                    callback()
                }
            }
            return {
                //表单验证规则
                rules: {
                    guestName: [{required: true, trigger: 'blur', message: '请输入访客姓名'}],
                    guestIdcard: [{required: true, trigger: 'blur', message: '请输入访客证件号码'}],
                    guestHealthyStatus: [{required: true, trigger: 'blur', message: '请输入健康状态'}],
                    gdid: [{required: true, trigger: 'blur', message: '请输入岗点id'}],
                    time: [{required: true, trigger: 'blur', message: '请输入来访时间'}],
                    guestTypeId: [{required: true, trigger: 'blur', message: '请输入人员类型id'}],
                    userId: [{required: true, trigger: 'blur', message: '请输入保安id'}],
                    guestReason: [{required: true, trigger: 'blur', message: '请输入来访原因'}]
                },
                visible: false,
                dataForm: {
                id: '',
                guestName: '',
                guestIdcard: '',
                guestHealthyStatus: '',
                gdid: '',
                time: '',
                guestTypeId: '',
                userId: '',
                guestReason: '',
                }
            }
        },
        methods: {
            init (id) {
                this.dataForm.id = id
                this.visible = true
                this.$nextTick
                (() => {
                    this.$refs['dataForm'].resetFields()
                    if(this.dataForm.id) {
                        this.$http({
                            url: '/bjba//tguestlog/'+this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            this.dataForm.id    = data.data.id
                            this.dataForm.guestName    = data.data.guestName
                            this.dataForm.guestIdcard    = data.data.guestIdcard
                            this.dataForm.guestHealthyStatus    = data.data.guestHealthyStatus
                            this.dataForm.gdid    = data.data.gdid
                            this.dataForm.time    = data.data.time
                            this.dataForm.guestTypeId    = data.data.guestTypeId
                            this.dataForm.userId    = data.data.userId
                            this.dataForm.guestReason    = data.data.guestReason
                        })
                    }
                })

            },
            // 表单提交
            // 表单提交
            dataFormSubmit () {
              this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.$http({
                        url: `/bjba/tguestlog/save`,
                        method: 'post',
                        data: this.dataForm
                    }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                         })
                        this.visible = false
                        this.$emit
                        ('refreshDataList')
                    } else if(data && data.code === 500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                    })
                    }
                })
            }
        }
    }
</script>
